(function () {
  function $(sel, root) { return (root || document).querySelector(sel); }

  function inCartDrawer(el) {
    if (!el) return false;
    return !!el.closest("cart-drawer, .global-drawer, [data-drawer-position]");
  }

  function getTermsUI(drawerRoot) {
    var root = drawerRoot || document;
    return {
      cb: $("#CartDrawer-Terms", root),
      err: $("#CartDrawer-TermsError", root),
      box: root.querySelector(".cart-drawer__terms")
    };
  }

  function showError(ui) {
    if (ui && ui.err) ui.err.style.display = "block";
    if (ui && ui.box) ui.box.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  function hideError(ui) {
    if (ui && ui.err) ui.err.style.display = "none";
  }

  function isAccepted(ui) {
    return !!(ui && ui.cb && ui.cb.checked);
  }

  // 1) Lock visible checkout-ish buttons/links inside drawer whenever we can find them
  function lockDrawerControls() {
    var drawer = document.querySelector("cart-drawer");
    if (!drawer) return;

    var ui = getTermsUI(drawer);
    if (!ui.cb) return;

    var locked = !ui.cb.checked;

    // targets: submit buttons, checkout links, anything that points to /checkout
    var targets = drawer.querySelectorAll(
      'button[name="checkout"], input[name="checkout"], a[href^="/checkout"], form[action*="/checkout"] button, form[action*="/checkout"] input[type="submit"]'
    );

    targets.forEach(function (el) {
      // don't disable the checkbox itself
      if (el === ui.cb) return;

      // disable buttons/inputs
      if (el.tagName === "BUTTON" || (el.tagName === "INPUT" && el.type === "submit")) {
        el.disabled = locked;
        el.setAttribute("aria-disabled", locked ? "true" : "false");
      }

      // also block pointer events for links
      el.style.pointerEvents = locked ? "none" : "";
      el.style.opacity = locked ? "0.5" : "";
    });
  }

  // 2) Hard block: intercept ANY submit/click that would checkout from inside drawer
  function hardBlockHandler(e) {
    var t = e.target;

    // click on link/button that triggers checkout
    var checkoutClick = t && t.closest
      ? t.closest('a[href^="/checkout"], button[name="checkout"], input[name="checkout"]')
      : null;

    // submit of any form inside drawer (especially CartDrawer-Form)
    var formSubmit = (e.type === "submit") ? e.target : null;

    var drawer = document.querySelector("cart-drawer");
    if (!drawer) return;

    var ui = getTermsUI(drawer);
    if (!ui.cb) return; // if UI not present, do nothing

    // If event is not coming from drawer, ignore
    if (checkoutClick && !inCartDrawer(checkoutClick)) return;
    if (formSubmit && !inCartDrawer(formSubmit)) return;

    // If this is a checkout attempt from drawer and terms not accepted -> block
    var isCheckoutAttempt =
      !!checkoutClick ||
      (formSubmit && (formSubmit.id === "CartDrawer-Form" || formSubmit.getAttribute("action") === "/cart" || formSubmit.getAttribute("action") === window.Shopify?.routes?.root + "cart"));

    if (isCheckoutAttempt && !isAccepted(ui)) {
      e.preventDefault();
      e.stopPropagation();
      showError(ui);
      lockDrawerControls();
    }
  }

  // bind once
  document.addEventListener("click", hardBlockHandler, true);
  document.addEventListener("submit", hardBlockHandler, true);

  // checkbox behavior + keep controls synced
  document.addEventListener("change", function (e) {
    if (!e.target || e.target.id !== "CartDrawer-Terms") return;
    var drawer = document.querySelector("cart-drawer");
    if (!drawer) return;
    var ui = getTermsUI(drawer);
    hideError(ui);
    lockDrawerControls();
  }, true);

  // initial + rerenders
  function tick() { lockDrawerControls(); }
  tick();

  var mo = new MutationObserver(function () { tick(); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
